<template>
    <TransitionRoot as="template" :show="open">
        <Dialog
            as="div"
            static
            class="fixed z-10 inset-0 overflow-y-auto"
            @close="open = false"
            :open="open"
        >
            <div
                class="
                    flex
                    items-end
                    justify-center
                    min-h-screen
                    pt-4
                    px-4
                    pb-20
                    text-center
                    sm:block
                    sm:p-0
                "
            >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <DialogOverlay
                        class="
                            fixed
                            inset-0
                            bg-gray-500 bg-opacity-75
                            transition-opacity
                        "
                    />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                    class="hidden sm:inline-block sm:align-middle sm:h-screen"
                    aria-hidden="true"
                    >&#8203;</span
                >
                <TransitionChild
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100 translate-y-0 sm:scale-100"
                    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        class="
                            inline-block
                            align-bottom
                            bg-white
                            rounded-lg
                            px-4
                            pt-5
                            pb-4
                            text-left
                            overflow-hidden
                            shadow-xl
                            transform
                            transition-all
                            sm:my-8
                            sm:align-middle
                            sm:max-w-sm
                            sm:w-full
                            sm:p-6
                        "
                    >
                        <div
                            class="
                                mx-auto
                                flex
                                items-center
                                justify-center
                                h-10
                                w-10
                                rounded-full
                                bg-indigo-100
                                fixed
                                -mt-3
                                ml-auto
                                inset-x-0
                                top-0
                                hidden
                            "
                        >
                            <PencilAltIcon class="h-5 w-5 text-indigo-600" />
                        </div>
                        <div class="mt-2">
                            <div class="text-center sm:mt-0">
                                <DialogTitle
                                    as="h3"
                                    class="
                                        text-lg
                                        leading-6
                                        font-medium
                                        text-gray-900
                                        hidden
                                    "
                                >
                                </DialogTitle>
                                <div class="mt-2 text-left">
                                    <form-user :edit="user"></form-user>
                                </div>
                            </div>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import { ref } from "vue";
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import { CheckIcon, PencilAltIcon } from "@heroicons/vue/outline";

export default {
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckIcon,
        PencilAltIcon,
    },
    mounted() {
        Eventing.listen("closeModal", () => (this.open = false));
    },
    created() {},
    data() {
        const open = ref(true);

        return {
            open,
            user: {},
        };
    },
    methods: {},
};
</script>
